import * as React from 'react';

import {  AllotmentRangeTypeEditorView } from "./allotment-range-type-editor.view";

interface  AllotmentRangeTypeEditorControllerProps {
    value: number | null;
    mode: ControlMode;
    onChanged: (value: number | null) => void;
    setBusy(isBusy: boolean);
    label?: string;
    required?: boolean;
}

export class AllotmentRangeTypeEditorController extends React.Component<AllotmentRangeTypeEditorControllerProps, any> {
    public constructor(props) {
        super(props);
    }

    public render() {
        return (
            < AllotmentRangeTypeEditorView
               
                required={this.props.required} onChanged={this.props.onChanged} value={this.props.value} mode={this.props.mode} label={this.props.label} />
        );
    }
}


// WEBPACK FOOTER //
// ./src/app/products/allotment-range/parts/allotment-range-type-editor.controller.tsx